import ICON_TYPE from 'Icons/mapping/serverIconTypes';

const knownIconTypesInFacetDesign = {
  [ICON_TYPE.ADD]: 'add',
  [ICON_TYPE.ADD_CASH]: 'add', // TODO: this is incorrectly mapped
  [ICON_TYPE.CHECK]: 'check',
  [ICON_TYPE.MESSAGE]: 'message',
};

export default knownIconTypesInFacetDesign;
